import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Input } from '@/components/ui/input'
import { ThresholdSlider } from './ThresholdSlider'
import { SwitchRow } from './SwitchRow'
import type { AudioClassOption, AudioConfigPatch } from '@/types'

export function AudioBody({
  audioClasses,
  patch,
}: {
  audioClasses: AudioClassOption[]
  patch: (p: AudioConfigPatch) => void
}) {
  const { t } = useTranslation('cameras')
  const [filter, setFilter] = useState('')
  const filtered = audioClasses.filter((a) => a.class_name.toLowerCase().includes(filter.toLowerCase()))
  return (
    <div className="space-y-2">
      <Input value={filter} onChange={(e) => setFilter(e.target.value)}
             placeholder={t('detection.audioFilter')} className="h-9" />
      <div className="max-h-72 overflow-y-auto rounded-md border border-border/50 divide-y divide-border/50">
        {filtered.map((a) => (
          <div key={a.audio_class_id}>
            <div className="flex items-center justify-between gap-3 px-3 py-2">
              <SwitchRow id={`audio-${a.audio_class_id}`} label={a.class_name} checked={a.enabled}
                onCheckedChange={(on) => patch({ audio_class_id: a.audio_class_id, enabled: on })} />
            </div>
            {a.enabled && (
              <div className="px-3 pb-2 space-y-1">
                <ThresholdSlider value={a.effective_threshold} ariaLabel={a.class_name}
                  onCommit={(v) => patch({ audio_class_id: a.audio_class_id, threshold_override: v })} />
                <div className="flex items-center justify-between text-xs text-muted-foreground">
                  <span>{t('detection.audioRecent')}: {a.recent_scores.length ? a.recent_scores.map((s) => `${Math.round(s * 100)}%`).join(', ') : '—'}</span>
                  {a.threshold_override !== null && (
                    <button type="button" className="text-primary underline"
                      onClick={() => patch({ audio_class_id: a.audio_class_id, threshold_override: null })}>{t('detection.audioReset')}</button>
                  )}
                </div>
              </div>
            )}
          </div>
        ))}
        {filtered.length === 0 && (
          <p className="px-3 py-2 text-xs text-muted-foreground">{t('detection.noMatch')}</p>
        )}
      </div>
    </div>
  )
}
